import {
    Box,
    FormControl,
    FormLabel,
    Stack,
    AlertTitle,
} from '@chakra-ui/react';
import { Text, Alert, AlertIcon } from 'components/v4';
import { Link as RouterLink } from 'react-router-dom';
import { Link as ChakraLink } from '@chakra-ui/react';
import { Field } from 'formik';
import { useEffect, useState } from 'react';
import FieldToolTip from '@/components/forms/new/FieldToolTip';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import {
    formLabelStyling,
    stackStyling,
} from '@/components/forms/new/formStyles';
import walkthroughIds from '../../walkthroughIds';

const LocationField = ({
    section,
    accountScope,
    submitData,
    setPlatformNumber,
    errors,
    touched,
    darkMode,
    locations = [],
    locationList,
    locationCount,
    isLocationDisabled,
    platformID,
    setSelectedLocation = () => {},
}) => {
    const singleLocation = locationCount === 1 ? locationList[0] : undefined;
    const hasLocationDropdown = locationCount > 1;
    const platformIndex = submitData?.findIndex(
        (platform) => platform?.platformID === platformID,
    );
    const platform = submitData[platformIndex];

    const handleSelectChange = (item) => {
        setPlatformNumber((prev) => {
            const newPlatformNumbers = [...prev];

            newPlatformNumbers[platformIndex] = {
                ...platform,
                addressID: item?.id,
            };
            return newPlatformNumbers;
        });
        setSelectedLocation(item);
    };

    useEffect(() => {
        if (platform?.locationID && Array.isArray(locations)) {
            const selected = locations.find(
                (location) => location.id === platform.locationID,
            );
            setSelectedLocation(selected);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [platform?.locationID, locations]);
    const [isHovered, setIsHovered] = useState(false);

    let renderLocationField;
    if (isLocationDisabled) {
        renderLocationField = (
            <Stack direction="row" width="100%" alignItems="center" spacing={2}>
                {/* <Switch mb={0} isDisabled isChecked={false} /> */}
            </Stack>
        );
    }
    if (singleLocation) {
        renderLocationField = (
            <Stack direction="row" width="100%" alignItems="center" spacing={2}>
                <Text>
                    {platform?.locationID === singleLocation.id
                        ? singleLocation?.name
                        : 'Not Allocated'}
                </Text>
            </Stack>
        );
    }
    if (hasLocationDropdown) {
        renderLocationField = (
            <Field
                component={DropDown}
                id={`${section}-location`}
                name={`${section}-location`}
                shownValue="description"
                currentId={platform?.addressID}
                handleSelectChange={handleSelectChange}
                accountScope={accountScope}
                darkMode={darkMode}
                data={locations}
                walkthroughid={
                    walkthroughIds.editNumbersGeneral.editPlatformNumbers
                        .ufLocation
                }
            />
        );
    }
    return locationCount === 0 ? (
        <Box padding="10px 0px">
            <Alert status="error">
                <AlertIcon />
                <Box flexDirection="column">
                    <AlertTitle>
                        No platform location exists for this country.
                    </AlertTitle>
                    Please create an associated Webex location for this numbers
                    country under{' '}
                    <ChakraLink
                        as={RouterLink}
                        to="/addresses"
                        textDecoration="underline">
                        TCAP Addresses
                    </ChakraLink>{' '}
                    to enable Webex Calling.
                </Box>
            </Alert>
        </Box>
    ) : (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={
                errors &&
                `${section}-location` in errors &&
                touched &&
                touched[`${section}-location`]
            }
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" sx={{ ...stackStyling(), width: '740px' }}>
                <Box width={190}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Location
                    </FormLabel>
                </Box>
                {renderLocationField}
                {isHovered && (
                    <FieldToolTip
                        label="Location attached to the Number"
                        ariaLabel={`${section}-location-tooltip`}
                        right={hasLocationDropdown ? '25px' : '360px'}
                        top={hasLocationDropdown ? '25px' : '20px'}
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default LocationField;
